module.exports = __webpack_public_path__ + "static/img/ico_wechat.ed1e226.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/application_intro/ico_wechat.png
// module id = Q2KP
// module chunks = 0